// Redirect the browser to the Cognito hosted-UI logout — same pattern as
// scoreadmin-fe. Used by AnnouncerRoleGate's minimal gate chrome (#881); this
// app has no persistent app-bar/account menu of its own to share it with.
export function handleLogout() {
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  const cognitoDomain = import.meta.env.VITE_COGNITO_AUTH_DOMAIN;
  const logoutUri = import.meta.env.VITE_COGNITO_POST_LOGOUT_REDIRECT_URI;
  if (clientId && cognitoDomain && logoutUri) {
    const url = `https://${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
    window.location.replace(url);
  }
}
